define(function(require) {

    function _getRepresentationColor(value, themeIdx) {
        return window.cartovista.externalInterface.map.activeThemeSet.getThemeByIndex(themeIdx).colorTheme.getRepresentation(value).color.rgba;
    };
    var DomUtil = require("cartovista").DomUtil;
    return {
        ID: "Freq_CS_FRA_ST_1",
        THEMESETS_IDS: ["Freq_CS_FRA_ST_1"],
        BOTTOM_PANEL: {
            PRINT_OPTIONS: {"landscape": true, "scale": 0.5},
            DEFAULTS: {
                ACTIVE_LAYER_ID: "GEO09E01_CS_FRA_STA_GEN",
                GRAPH_TYPE: "line",
                GRAPH_DATA_ORIENTATION: "rows",
                PADDING: {"left": 30, "top": 0, "right": 15, "bottom": 0},
                HEIGHT_FN: function() {
                    if (!DomUtil.isResponsiveUI()) return $(".cv-left-bottom-pane").height() - 80;
                    else return 315;
                },
                WIDTH_FN: function() {
                    if (!DomUtil.isResponsiveUI()) return $(".cv-left-bottom-pane").width() - 40;
                    else return $("#cv-responsiveBbGraphsBottom").width() - 10;
                },
                X_DATA_NAMES: ["1999-2000", "2000-2001", "2001-2002", "2002-2003", "2003-2004", "2004-2005", "2005-2006", "2006-2007", "2007-2008",
                               "2008-2009", "2009-2010", "2010-2011", "2011-2012", "2012-2013", "2013-2014", "2014-2015", "2015-2016", "2016-2017",
                               "2017-2018", "2018-2019", "2019-2020", "2020-2021", "2021-2022", "2022-2023", "2023-2024"],
                X_AXIS_LABEL: "Années scolaires",
                Y_AXIS_LABEL: "%",
                X_AXIS_TICK_ROTATE: -90,
                TOOLTIP_TITLE_FN: function(x, graph) { return "Année scolaire " + graph.categories()[x]; },
                //TOOLTIP_VALUE_FN: function(y, graph) { return y + "%"; }
            },
            TABS: [
                {
                    BUTTON_TITLE: "Sexes réunis - 1999-2000 à 2023-2024",
                    GRAPHS: [
                        {
                            TITLE: "Évolution des taux annuels de sorties sans diplôme ni qualification au secondaire à la FGJ, sexe réunis, 1999-2000 à 2023-2024",
                            DATA_SOURCES: [
                                {
                                    LAYER_ID: "GEO09E01_CS_FRA_STA_GEN",
                                    DATATABLE_ID: "t_GEO09E01_CS_FRA_STA_GEN_frequentation",
                                    DATACOLUMNS_IDS: ["TX_T_1999_2000", "TX_T_2000_2001", "TX_T_2001_2002", "TX_T_2002_2003", "TX_T_2003_2004",
                                                      "TX_T_2004_2005", "TX_T_2005_2006", "TX_T_2006_2007", "TX_T_2007_2008", "TX_T_2008_2009",
                                                      "TX_T_2009_2010", "TX_T_2010_2011", "TX_T_2011_2012", "TX_T_2012_2013", "TX_T_2013_2014",
                                                      "TX_T_2014_2015", "TX_T_2015_2016", "TX_T_2016_2017", "TX_T_2017_2018", "TX_T_2018_2019",
                                                      "TX_T_2019_2020", "TX_T_2020_2021", "TX_T_2021_2022", "TX_T_2022_2023", "TX_T_2023_2024"],
                                }
                            ]
                        }
                    ]
                }, {
                    BUTTON_TITLE: "Sexe masculin - 1999-2000 à 2023-2024",
                    GRAPHS: [
                        {
                           TITLE: "Évolution des taux annuels de sorties sans diplôme ni qualification au secondaire à la FGJ, sexe masculin, 1999-2000 à 2023-2024",
                           DATA_SOURCES: [
                               {
                                   LAYER_ID: "GEO09E01_CS_FRA_STA_GEN",
                                   DATATABLE_ID: "t_GEO09E01_CS_FRA_STA_GEN_frequentation",
                                   DATACOLUMNS_IDS: ["TX_M_1999_2000", "TX_M_2000_2001", "TX_M_2001_2002", "TX_M_2002_2003", "TX_M_2003_2004",
                                                     "TX_M_2004_2005", "TX_M_2005_2006", "TX_M_2006_2007", "TX_M_2007_2008", "TX_M_2008_2009",
                                                     "TX_M_2009_2010", "TX_M_2010_2011", "TX_M_2011_2012", "TX_M_2012_2013", "TX_M_2013_2014",
                                                     "TX_M_2014_2015", "TX_M_2015_2016", "TX_M_2016_2017", "TX_M_2017_2018", "TX_M_2018_2019",
                                                     "TX_M_2019_2020", "TX_M_2020_2021", "TX_M_2021_2022", "TX_M_2022_2023", "TX_M_2023_2024"],
                               }
                           ]
                       }
                    ]
                }, {
                    BUTTON_TITLE: "Sexe féminin - 1999-2000 à 2023-2024",
                    GRAPHS: [
                        {
                            TITLE: "Évolution des taux annuels de sorties sans diplôme ni qualification au secondaire à la FGJ, sexe féminin, 1999-2000 à 2023-2024",
                            DATA_SOURCES: [
                                {
                                    LAYER_ID: "GEO09E01_CS_FRA_STA_GEN",
                                    DATATABLE_ID: "t_GEO09E01_CS_FRA_STA_GEN_frequentation",
                                    DATACOLUMNS_IDS: ["TX_F_1999_2000", "TX_F_2000_2001", "TX_F_2001_2002", "TX_F_2002_2003", "TX_F_2003_2004",
                                                      "TX_F_2004_2005", "TX_F_2005_2006", "TX_F_2006_2007", "TX_F_2007_2008", "TX_F_2008_2009",
                                                      "TX_F_2009_2010", "TX_F_2010_2011", "TX_F_2011_2012", "TX_F_2012_2013", "TX_F_2013_2014",
                                                      "TX_F_2014_2015", "TX_F_2015_2016", "TX_F_2016_2017", "TX_F_2017_2018", "TX_F_2018_2019",
                                                      "TX_F_2019_2020", "TX_F_2020_2021", "TX_F_2021_2022", "TX_F_2022_2023", "TX_F_2023_2024"],
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        RIGHT_PANEL: {
            DEFAULTS: {
                GRAPH_TYPE: "bar",
                GRAPH_DATA_ORIENTATION: "columns",
                PADDING: {"top": 0, "right": 15, "bottom": -10, "left": 30},
                HEIGHT_FN: function() { return 325;},
                WIDTH_FN: function() {
                    if (!DomUtil.isResponsiveUI()) return $(".cv-right-top-pane").width() - 30;
                    else return $("#cv-responsiveBbGraphsView").width() - 10;
                },
                DATA_AUTO_SORT: "asc",
                X_AXIS_TICK_VALUES: [], //enlève les ticks
                Y_AXIS_LABEL: "%",
                //TOOLTIP_VALUE_FN: function(y, graph) { return y + "%";}
            },
            TABS : [
                {
                    BUTTON_TITLE: "Sexes réunis",
                    GRAPHS: [
                        {
                            ACTIVE_LAYER_ID: "GEO09E01_CS_FRA_STA_GEN",
                            TITLE: "Taux annuel de sorties sans diplôme ni qualification au secondaire à la FGJ, en fonction du sexe, {{TEXT}} (%)",
                            DATA_SOURCES: [
                                {
                                    LAYER_ID: "GEO09E01_CS_FRA_STA_GEN",
                                    DATATABLE_ID: "t_GEO09E01_CS_FRA_STA_GEN_frequentation",
                                    DATACOLUMNS_IDS: ["TX_M_{{VALUE}}", "TX_F_{{VALUE}}"],
                                    NO_SELECTION_SHOW_ALL_FEATURES: true
                                }
                            ],
                            DATA_AUTO_SORT: "asc",
                            Y_AXIS_MAX_VALUE : 95,
                            X_AXIS_LABEL: {"text": "CSS Franco.", "position": "outer-right"},
                            X_DATA_NAMES: ["Sexe masculin", "Sexe féminin"],
                            DATA_COLORS: {"Sexe masculin" : "#095797", "Sexe féminin": "#68CEBA"},
                        },
                        {
                            ACTIVE_LAYER_ID: "GEO09E01_CS_FRA_STA_GEN",
                            TITLE: "Taux annuel de sorties sans diplôme ni qualification au secondaire à la FGJ, sexe réunis, {{TEXT}} (%)",
                            DATA_SOURCES: [
                                {
                                    LAYER_ID: "GEO09E01_CS_FRA_STA_GEN",
                                    DATATABLE_ID: "t_GEO09E01_CS_FRA_STA_GEN_frequentation",
                                    DATACOLUMNS_IDS: ["TX_T_{{VALUE}}"],
                                    NO_SELECTION_SHOW_ALL_FEATURES: true
                                }
                            ],
                            Y_AXIS_MAX_VALUE : 95,
                            X_AXIS_LABEL: {"text": "CSS Franco.", "position": "outer-right"},
                            X_DATA_NAMES: ["FGJ"],
                            DATA_NAMES: {"FGJ": "CSS et CS francophone et à statut particulier"},
                            DATA_COLORS: {"FGJ": "#000000"},
                            ON_RENDERED_FN: function(graph) {
                                _.forEach(graph.data("FGJ")[0].values, function(valueObj) {
                                    graph.$.main.select(".bb-bar-" + valueObj.index).style("fill", _getRepresentationColor(valueObj.value, 1));
                                });
                            },
                            TOOLTIP_NAME_FN: function(name) { return "FGJ"; },
                            TOOLTIP_ON_SHOWN_FN: function(graph) {
                                var value = graph.data("FGJ")[0].values[graph.categories().indexOf(graph.$.tooltip.select("th").text())].value;
                                graph.$.tooltip.select("td.name span").style("background-color", _getRepresentationColor(value, 1));
                            },
                        }
                    ]
                },
            ]
        }
    };
});
